import baseURL from "../baseUrl";
import { timeZone } from "../constants";
import getAccessToken from "../../accessToken";

class Home {
  async getHome(data: { lat: string; lng: string }) {
    const accessToken = getAccessToken();
    const response = await fetch(`${baseURL}/home`, {
      method: "get",
      headers: {
        timezone: timeZone,
        Authorization: `Bearer ${accessToken}`,
        zoneId: JSON.stringify(["1"]),
        longitude: data.lng,
        latitude: data.lat,
      },
    });
    return response.json();
  }

  async getEstablishment(data: string) {
    const accessToken = getAccessToken();
    const response = await fetch(`${baseURL}/establishment/${data}`, {
      method: "get",
      headers: {
        timezone: timeZone,
        Authorization: `Bearer ${accessToken}`,
        zoneId: JSON.stringify(["1"]),
      },
    });
    return response.json();
  }

  async getEstablishmentByType(data: string) {
    const cordinates = JSON.parse(`${localStorage.getItem('cord')}`)
    const accessToken = getAccessToken();
    const response = await fetch(`${baseURL}/get-establishment/${data}`, {
      method: "get",
      headers: {
        timezone: timeZone,
        Authorization: `Bearer ${accessToken}`,
        zoneId: JSON.stringify(["1"]),
        longitude: cordinates.lng,
        latitude: cordinates.lat,
      },
    });
    return response.json();
  }
}

const instance = new Home();

export default instance;
